"use client";

import React from "react";
import { Hexagon, Square, Triangle, Circle, Diamond, Octagon } from "lucide-react";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { FormProvider } from "@/integrations/forms/FormProvider";
const tools = [{
  id: 1,
  title: "01",
  icon: Hexagon
}, {
  id: 2,
  title: "02",
  icon: Square
}, {
  id: 3,
  title: "03",
  icon: Triangle
}, {
  id: 4,
  title: "04",
  icon: Circle
}, {
  id: 5,
  title: "05",
  icon: Diamond
}, {
  id: 6,
  title: "06",
  icon: Octagon
}];
export default function ToolsPreview() {
  return <section data-section-id="116873" id="caddie-features" className="dark bg-[#0A0E14] text-[#F4EFE6] py-24 border-t border-[#B8922A]/20">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="font-sans text-3xl md:text-4xl font-bold text-[#F4EFE6] mb-4 tracking-[0.2em] uppercase">
            The Caddie Suite
          </h2>
          <p className="font-serif text-[#F4EFE6]/60 max-w-2xl mx-auto text-lg md:text-xl">
            Systematic Trading, Simplified. Precision-engineered educational frameworks designed for the modern institutional trader.
          </p>
        </div>

        <div className="bg-[#141A22] p-6 md:p-10 border border-[#B8922A]/20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {tools.map((tool, i) => {
            const Icon = tool.icon;
            return <Card key={tool.id} data-index={i} className="bg-[#0A0E14] opacity-90 relative border-[#B8922A]/10 border-l-2 border-l-[#B8922A]/40 rounded-none overflow-hidden group hover:opacity-100 hover:border-[#B8922A] transition-all duration-500">
                  <div className="absolute top-4 right-4">
                    <Badge variant="outline" className="text-[10px] text-[#B8922A] border-[#B8922A]/40 font-sans tracking-[0.2em] rounded-none px-3 py-1 bg-[#0A0E14]/80 backdrop-blur-sm">
                      PREVIEW
                    </Badge>
                  </div>
                  <CardHeader className="pt-10 pb-8 px-8 flex flex-col items-center text-center gap-6">
                    <Icon className="w-10 h-10 text-[#B8922A] stroke-[1]" />
                    <CardTitle className="font-sans text-[14px] font-bold text-[#F4EFE6] tracking-[0.15em] uppercase">
                      {tool.title}
                    </CardTitle>
                  </CardHeader>
                </Card>;
          })}
          </div>
        </div>

        <div className="mt-20 text-center max-w-xl mx-auto">
          <h3 className="font-sans text-4xl text-[#F4EFE6] mb-4 tracking-[0.15em] uppercase">
            Founding Access
          </h3>
          <p className="font-serif text-[#F4EFE6]/60 mb-8 text-lg">
            Secure your position in the next cohort and gain early access to the full Caddie systematic toolset.
          </p>
          <FormProvider formId="tools-waitlist" apiUrl="https://api.example.com/waitlist">
            <form className="flex flex-col sm:flex-row gap-0 justify-center border border-[#B8922A]/30 p-1 bg-[#141A22]/50">
              <input type="email" name="email" placeholder="Enter your email address" className="bg-transparent text-[#F4EFE6] px-6 py-4 font-serif focus:outline-none w-full placeholder:text-[#F4EFE6]/40" required />
              <Button type="submit" variant="default" className="rounded-none font-sans tracking-[0.2em] px-10 py-6 text-xs bg-[#B8922A] text-[#0A0E14] hover:bg-[#D4AE52] transition-colors">
                JOIN THE WAITLIST
              </Button>
            </form>
          </FormProvider>
        </div>
      </div>
    </section>;
}